import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchPriceLabelReports } from 'utils/api/priceLabelReportApi'
import { columns, FILTER_FIELD_PRICE_LABEL_REPORT } from './utils'

interface PriceLabelReportDataTableProps {
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const PriceLabelReportDataTable = ({
  loading,
  setLoading,
}: PriceLabelReportDataTableProps) => {
  const [reportResponse, setReportResponse] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getPriceLabelReportData = async () => {
    setLoading(true)
    const queries = getAllQueries()

    try {
      const { data } = await fetchPriceLabelReports({
        limit: queries.limit || 10,
        page: queries.page || 1,
        search: queries.search,
        filters: queries[FILTER_FIELD_PRICE_LABEL_REPORT],
      })

      setReportResponse({ ...data })
    } catch (error) {
      setReportResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPriceLabelReportData()
  }, [search])

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : reportResponse.docs}
        identifier="_id"
      />

      <DataTablePagination
        currentPage={reportResponse?.page}
        totalPages={reportResponse?.totalPages}
        hasNextPage={reportResponse?.hasNextPage}
        hasPrevPage={reportResponse?.hasPrevPage}
        limit={reportResponse?.limit}
        nextPage={reportResponse?.nextPage}
        prevPage={reportResponse?.prevPage}
        disabled={loading}
      />
    </>
  )
}

export default PriceLabelReportDataTable
